import {
  CalendarBasedUliCreationFormModel,
  CreateAndAllocateUliRequestModel,
  UliCreateSelectionModel,
} from '../../models';
import { UliFormModel, UliRule } from '../models';
import { MultiStopUliFormModel } from '../models/uli-multi-stop-creation.model';

export class UliCreate {
  public static readonly type = '[UliCreation] Create Uli Item';

  constructor(public payload: UliFormModel) {}
}

export class UliCreateAndAllocate {
  public static readonly type = '[UliCreation] Create And Allocate Uli Item';

  constructor(public payload: CreateAndAllocateUliRequestModel) {}
}

export class MultiStopUliCreate {
  public static readonly type = '[UliCreation] Create Multi Stop Uli Item';

  constructor(public payload: MultiStopUliFormModel) {}
}

export class UliCreationCompartmentListLoad {
  public static readonly type = '[UliCreation] Load Compartment List';

  constructor(public payload: number) {}
}

export class UliCreationDeliveryPartyAddressesLoad {
  public static readonly type = '[UliCreation] Load Delivery Party Addresses List';

  constructor(public payload: { filter: string; limit?: number }) {}
}

export class UliCreationCarriersLoad {
  public static readonly type = '[UliCreation] Load Carriers List';

  constructor(public payload: { filter: string; limit?: number }) {}
}

export class UliCreationHubTruckMappingLoad {
  public static readonly type = '[UliCreation] Load Hub Truck Mapping';

  constructor(public payload: number) {}
}

export class UliCreationDefaultHubTruckMappingLoad {
  public static readonly type = '[UliCreation] Load Default Hub Truck Mapping';

  constructor(public payload: number) {}
}

export class UliLoadSearch {
  public static readonly type = '[UliCreation] Load Search';

  constructor(public payload: { loadNumber: string }) {}
}

export class UliClearLoadSearch {
  public static readonly type = '[UliCreation] Clear Load Search Result';
}

export class SetUliRule {
  public static readonly type = '[UliCreation] Set Uli Rule';

  constructor(public payload: UliRule) {}
}

export class UliCreationSetPrefill {
  public static readonly type = '[UliCreation] Set Uli Prefill Data';

  constructor(public payload: UliCreateSelectionModel) {}
}

export class UliCreationSetCalendarPrefill {
  public static readonly type = '[UliCreation] Set Uli Calendar Prefill Data';

  constructor(public payload: CalendarBasedUliCreationFormModel) {}
}

export class UliCreationClearStorage {
  public static readonly type = '[UliCreation] Clear Storage Data';
}

export class UliCreationInitialState {
  public static readonly type = '[UliCreation] Set Initial State';
}
